import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import { selectProject } from '../../actions'

export default function ProjectSelect() {
  const dispatch = useDispatch()
  const { selectedProjectId, projects } = useSelector(state => state)

  const handleProjectSelect = event => {
    const id = event.target.value
    dispatch(selectProject(id))
  }

  return (
    <FormControl variant="filled" size="small" margin="dense">
      <InputLabel id="selectproject-label">Project Select</InputLabel>
      <Select
        id="selectproject"
        value={selectedProjectId ? selectedProjectId : ''}
        onChange={handleProjectSelect}
      >
        {projects.map(project => {
          return (
            <MenuItem dense key={project.id} value={project.id}>
              {project.name}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
